<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    id: {
      type: String,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errortext: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    inputVal: function (newValue) {
      if (newValue != '') {
        let a = this.ConvertToEnglish(newValue)
        let b = a.replace(/\D/g, '')
        if (b.length > 0) {
          let result = this.Commafy(b)
          this.$nextTick(function () {
            this.inputVal = result
          })
        } else {
          this.inputVal = ''
        }
      } else {
        let result = newValue.replace(/\D/g, '')
        this.$nextTick(function () {
          this.inputVal = result
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="mainInput">
      <div class="labelStyle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</div>
      <input
        :id="id"
        autocomplete="off"
        :class="showError ? `errorStyle` : `inputStyle`"
        :maxlength="maxlength"
        :minlength="minlength"
        v-model="inputVal"
        type="text"
        :placeholder="placeholder"
        required
        :disabled="disable"
      />
    </div>
    <div v-if="showError" class="errorClass">{{ errortext }}</div>
  </div>
</template>

<style lang="scss" scoped>
.mainInput {
  display: flex;
  align-items: center;
}
.errorStyle {
  line-height: 17px;
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #fe5e61;
  padding: 6px 10px;
  box-sizing: border-box;
}
.inputStyle {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorClass {
  margin-right: 100px;
  font-size: 10px;
  color: #fe5e61;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
.labelStyle {
  min-width: 90px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
